import { ThemeComponentType } from '../types';

export const TimeInput: ThemeComponentType = {
  styles: theme => ({
    input: {
      '&&:read-only': {
        backgroundColor: 'white',
      },
    },
    controls: {
      height: 'auto',
    },
    timeInput: {
      color: theme.black,
      fontSize: theme.fontSizes.md,
      fontWeight: 500,
    },
    icon: {
      top: -1,
    },
  }),
};
